var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"shadow-lg",attrs:{"variant":_vm.value ? 'ligh' : 'dark'},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('img',{staticClass:"mx-n1",style:(_vm.value ? 'height:1.5em' : 'height:1.5em;filter:invert(90%)'),attrs:{"src":require("../assets/interface/square.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }